export default __webpack_public_path__ + "static/media/device_connected.16215977.png";